(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["dd-shade-search"] && !Shopify.designMode) return;
  try {
    (() => {
    const normalize = (value) => {
      const text = value.trim().toLowerCase().replace(/^#\s*/, '').replace(/\s+/g, ' ');
      return /^\d+$/.test(text) ? String(Number(text)) : text;
    };

    function initialize(scope) {
      scope.querySelectorAll('[data-dd-shade-search]').forEach((controls) => {
        if (controls.dataset.ready) return;
        const picker = controls.closest('[data-dd-high-variant-picker]');
        const list = picker && picker.querySelector('.block-swatch-list');
        const input = controls.querySelector('[data-dd-shade-query]');
        const clear = controls.querySelector('[data-dd-shade-clear]');
        const status = controls.querySelector('[data-dd-shade-status]');
        if (!list || !input || !clear || !status) return;
        const entries = Array.from(list.querySelectorAll('.dd-high-variant-selector')).map((radio) => ({
          radio, item: radio.closest('.block-swatch'), label: normalize(radio.value)
        }));
        if (!entries.length) return;
        controls.dataset.ready = 'true';
        list.id = input.getAttribute('aria-controls');
        list.setAttribute('role', 'radiogroup');
        list.setAttribute('aria-label', input.labels[0].textContent);
        const selectedLabel = picker.querySelector('.product-form__option-name');
        if (selectedLabel) {
          selectedLabel.id = input.id + '-selected';
          list.setAttribute('aria-labelledby', selectedLabel.id);
        }
        let matches = entries;

        function update() {
          const query = normalize(input.value);
          matches = entries.filter((entry) => !query || entry.label.includes(query));
          const exact = matches.find((entry) => entry.label === query);
          if (exact) matches = [exact, ...matches.filter((entry) => entry !== exact)];
          entries.forEach((entry) => {
            entry.item.hidden = !matches.includes(entry);
            entry.item.classList.toggle('dd-shade-exact', Boolean(query) && entry === exact);
            entry.radio.tabIndex = -1;
          });
          const focusTarget = matches.find((entry) => entry.radio.checked) || matches[0];
          if (focusTarget) focusTarget.radio.tabIndex = 0;
          clear.disabled = input.value.length === 0;
          const template = !matches.length ? controls.dataset.emptyTemplate : query ? controls.dataset.countTemplate : controls.dataset.allTemplate;
          status.textContent = template.replace('[count]', String(matches.length)).replace('[total]', String(entries.length));
          list.scrollTop = 0;
        }

        function reset() {
          input.value = '';
          update();
          input.focus();
        }

        input.addEventListener('input', update);
        input.addEventListener('search', update);
        input.addEventListener('keydown', (event) => {
          if (event.key === 'Escape') { event.preventDefault(); reset(); }
          if (event.key === 'Enter' || event.key === 'ArrowDown') {
            event.preventDefault();
            if (matches[0]) matches[0].radio.focus();
          }
        });
        clear.addEventListener('click', reset);
        list.addEventListener('change', (event) => {
          if (!event.target.matches('.dd-high-variant-selector')) return;
          entries.forEach((entry) => { entry.radio.tabIndex = entry.radio === event.target ? 0 : -1; });
        });
        picker.classList.add('dd-shade-search-enabled');
        controls.hidden = false;
        update();
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initialize(document));
    } else {
      initialize(document);
    }
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  })();
  } catch(e) { console.error(e); }
})();

})();
